export default "__VITE_ASSET__f51f4ee1__"